export class LyantheJournalentryModel {
  lineNumber: number
  Description: string
  VatCode: string
  VATPerc: string
  LedgerCode: string
  LedgerDescr: string
  VATBox: string
  DC: string
  Amount: string

  constructor(data) {
    this.lineNumber = data.lineNumber ? data.lineNumber : null
    this.Description = data.Description ? data.Description : null
    this.VatCode = data.VatCode ? data.VatCode : null

    this.VATPerc = data.VATPerc ? data.VATPerc : null
    this.LedgerCode = data.LedgerCode ? data.LedgerCode : null
    this.LedgerDescr = data.LedgerDescr ? data.LedgerDescr : null
    this.VATBox = data.VATBox ? data.VATBox : null
    this.DC = data.DC ? data.DC : null
    this.Amount = data.Amount ? data.Amount : null
  }
}



// WEBPACK FOOTER //
// ./src/app/main/models/lyanthe/lyanthe.journalentry.model.ts